/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function SucceededFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="prospecting_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="succeeded"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'null'}
        id="prospecting_ongoing_filter"
        label={intl.formatMessage({
          id: 'ongoing',
          defaultMessage: 'En cours'
        })}
        name="succeeded"
        onChange={handleChangeEvent(onChange)}
        value="null"
      />
      <Radio
        checked={value === 'true'}
        id="prospecting_succeeded_filter"
        label={intl.formatMessage({
          id: 'success',
          defaultMessage: 'Succès'
        })}
        name="succeeded"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="prospecting_failure_filter"
        label={intl.formatMessage({
          id: 'failure',
          defaultMessage: 'Échec'
        })}
        name="succeeded"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default SucceededFilter
